import classnames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { Label } from '@eika/label';

import NotificationBadge from './NotificationBadge';
import TextContent from './TextContent';

import './ButtonLinkItem.scss';

interface ButtonLinkItemProps {
    children: React.ReactNode;
    onClick: () => void;
    className?: string;
    description?: string;
    labels?: ReturnType<typeof Label>[] | ReturnType<typeof Label>;
    notificationNumber?: number;
    notificationScreenReaderText?: string;
}

const ButtonLinkItem: React.FC<ButtonLinkItemProps> = ({
    children,
    onClick,
    className,
    description,
    labels,
    notificationNumber,
    notificationScreenReaderText,
}) => {
    return (
        <li>
            <button
                type="button"
                className={classnames('sgw-link-list-item button-link-item', className)}
                onClick={onClick}
            >
                <TextContent title={children} labels={labels} description={description} />
                <span className="sgw-link-list-item__visual">
                    <NotificationBadge number={notificationNumber} screenReaderText={notificationScreenReaderText} />
                    <Icon type={IconTypes.PIL_HOEYRE} />
                </span>
            </button>
        </li>
    );
};

export default ButtonLinkItem;
